import { Continent } from '../external-data/types';
import { ContinentInfo } from './types';

export class LocationService {
  /*
   * Here we map the display names that will show up in the UI to the parameters
   * that the backend expects. Note the mapping from 'Oceania' to 'Australia'
   * and from 'Americas' to 'America'.
   */
  static continents: ContinentInfo[] = [
    { displayName: 'americas', continent: Continent.AMERICA },
    { displayName: 'europe', continent: Continent.EUROPE },
    { displayName: 'africa', continent: Continent.AFRICA },
    { displayName: 'asia', continent: Continent.ASIA },
    { displayName: 'oceania', continent: Continent.AUSTRALIA },
  ];

  static getDisplayName(continent: Continent): string | undefined {
    return this.continents.find((continentInfo: ContinentInfo) => continentInfo.continent === continent)?.displayName;
  }
}
